import type { ApplicationContext } from '../shared-types'
import type { Options, Placement } from 'tooltip.js'

import Tooltip from './uikit-tooltip'

function isPlacement(placement: string): placement is Placement {
  return (
    placement !== null &&
    (placement === 'top' ||
      placement === 'bottom' ||
      placement === 'left' ||
      placement === 'right')
  )
}

interface TooltipDelay {
  show: number
  hide: number
}

export default (appContext: ApplicationContext): ApplicationContext => {
  const { eventHub, onDomLoad } = appContext

  onDomLoad(($dom) => {
    $dom.trigger('tooltipsRendered')
  })

  eventHub.$on('modal-opened', () => {
    $(document).trigger('tooltipsRendered')
  })

  // Disabling eslint until we can refactor this to not use jQuery
  /* eslint-disable */
  $(document).on('tooltipsRendered', function (_event, context, elem) {
    // Allow to pass context to initialize tooltips based on part of the DOM, not the whole document every time
    const $context = context ? $(context) : $(document)
    const selector = elem ? $(elem) : 'a[rel~=tooltip], [data-toggle=tooltip]'
    // Drop-in replacement for Bootstrap's Tooltip
    $context.find(selector).each((_idx, element) => {
      const $tooltip = $(element)
      const title = $tooltip.attr('title') || ''
      const html = !!$tooltip.data('html')
      const textLeft = !!$tooltip.data('textLeft')

      const options: Options = { title: title, html: html, textLeft }
      const hasDynamicTooltip = element.dataset.dynamicTooltip

      // do not initialize a tooltip object multiple times on the same element
      if ($tooltip.data('tooltip-instance')) {
        return
      }

      if (hasDynamicTooltip) {
        element.classList.add('sf-truncate')
        element.classList.add('sf-noscroll')
      }

      const isWiderThanContainer = element.offsetWidth < element.scrollWidth

      if (hasDynamicTooltip && !isWiderThanContainer) {
        return false
      }

      if ($tooltip.data('placement')) {
        const placement = $tooltip.data('placement') as string

        if (isPlacement(placement)) {
          options.placement = placement
        }

        options.delay = 100
      }

      if ($tooltip.data('tooltip-delay')) {
        options.delay = $tooltip.data('tooltip-delay') as
          | number
          | TooltipDelay
          | undefined
      }

      if ($tooltip.data('container') === 'body') {
        options.container = document.body
        options.boundariesElement = document.body
      }

      const tooltip = new Tooltip(element, {
        ...options,
        size: $tooltip.data('tooltip-size') as 'sm' | 'md' | 'lg',
      })
      $tooltip.data('tooltip-instance', tooltip)

      $(document).one(
        'turbolinks:before-cache turbolinks:before-render',
        () => {
          if ($tooltip.data('tooltip-instance')) {
            tooltip.dispose()
          }
        }
      )
    })
  })

  return appContext
}
